import React from "react";

const PhotoExplanation = props => {
    return (
        <p>{props.explanation}</p>
    )
};

export default PhotoExplanation;